import styled from 'styled-components';

// The selected card overlaps the selected-label strip above it. The label's
// bottom padding (SELECTED_LABEL_OVERLAP_PX + 8) is offset by the card's
// negative top margin so the strip and the card meet flush.
export const SELECTED_LABEL_OVERLAP_PX = 20;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardWrapper = styled.div<{ $isSelected: boolean }>`
  position: relative;
  z-index: 1;
  border: 1px solid ${(p) => p.theme.kallisto.color.border.static.borderNeutral};
  border-radius: 16px;
  overflow: hidden;
  background-color: ${(p) => p.theme.kallisto.color.background.static.backgroundLayer02};
  ${(p) => p.$isSelected && `margin-top: -${SELECTED_LABEL_OVERLAP_PX}px;`}
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const TransportCardSection = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`;

export const TransportDivider = styled.hr`
  margin: 0;
  border: 0;
  border-top: 1px solid ${(p) => p.theme.kallisto.color.border.static.borderNeutral};
`;

export const PriceArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px 16px;
  border-top: 1px solid ${(p) => p.theme.kallisto.color.border.static.borderNeutral};

  @media (min-width: 768px) {
    width: 216px;
    min-width: 216px;
    padding: 16px;
    border-top: none;
    border-left: 1px solid ${(p) => p.theme.kallisto.color.border.static.borderNeutral};
    align-items: flex-end;
  }
`;

export const PriceAndButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    margin-top: auto;
  }
`;
